import { Injectable } from '@angular/core';
import { ApiService } from '../../../../_core/_services/api.service';
import { BaseEntityService } from './base-entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DevicesService extends BaseEntityService<any> {
  protected endpoint = 'device';

  constructor(api: ApiService) {
    super(api);
  }

  // Override addData to handle Device-specific logic
  override addData(data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Adding Device:', new_value);

    return this.api.postAPI<any>('device', new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          this.data.push(res.body);
          this.data$.next([...this.data]);
          console.log('Device data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Override updateData to handle Device-specific logic
  override updateData(id: number, data: any): Observable<any> {
    const new_value = { ...data };
    console.log('Updating Device:', { id, data: new_value });

    return this.api.putAPI<any>('device', id, new_value).pipe(
      map((res: any) => {
        if (res && res.body) {
          const index = this.data.findIndex((device) => device.id === id);
          if (index !== -1) {
            this.data[index] = { ...this.data[index], ...res.body };
            this.data$.next([...this.data]);
            console.log('Device data updated, current count:', this.data.length);
          }
        }
        return res;
      })
    );
  }

  // Override deleteData to handle Device-specific logic
  override deleteData(id: number): Observable<any> {
    console.log('Deleting Device:', id);

    return this.api.deleteAPI<any>('device', id).pipe(
      map((res: any) => {
        console.log('Device delete response:', res);
        const index = this.data.findIndex((device) => device.id === id);
        if (index !== -1) {
          this.data.splice(index, 1);
          this.data$.next([...this.data]);
          console.log('Device data updated, current count:', this.data.length);
        }
        return res;
      })
    );
  }

  // Legacy methods for backward compatibility
  getDevices(queryParams?: any) {
    return this.getData(queryParams);
  }

  getDeviceById(id: any) {
    return this.api.getAPI<any>(`device/${id}`);
  }

  getDeviceBySerialNo(serial_no: any) {
    console.log('Serial No: ', serial_no);
    //remove spaces form the serial_number
    serial_no = serial_no.replace(/\s/g, '');
    return this.api.getAPI<any>(`device/serial-no/${serial_no}`);
  }

  addDevice(value: any) {
    return this.addData(value);
  }

  updateDevice(id: any, value: any) {
    return this.updateData(id, value);
  }

  deleteDevice(id: any) {
    return this.deleteData(id);
  }
}
